import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonIcon,
} from '@ionic/react';
import { informationCircleOutline, phonePortraitOutline } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Seesor V4</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen className="ion-padding">
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Seesor V4</IonTitle>
          </IonToolbar>
        </IonHeader>

        <div className="home-container">
          <h1>Welcome to Seesor V4</h1>
          <p>An Ionic-React Vite mobile/web hybrid application</p>

          <IonCard>
            <IonCardHeader>
              <IonIcon icon={phonePortraitOutline} size="large" />
              <IonCardTitle>Cross-Platform Ready</IonCardTitle>
              <IonCardSubtitle>Web, iOS & Android</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              This application is built with Ionic React and Vite, managed by
              Capacitor for seamless deployment to web and mobile platforms.
            </IonCardContent>
          </IonCard>

          <IonButton expand="block" onClick={() => history.push('/about')}>
            <IonIcon slot="start" icon={informationCircleOutline} />
            Learn More
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
